import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import './tooltip.css';
import { ReactNode } from 'react';

interface TooltipProps {
  title: ReactNode;
  position?: 'top' | 'bottom';
  animated?: boolean;
  color?: string;
  icon?: ReactNode;
  parentClass?: string;
  contentClass?: string;
}
const tooltipContainer = cva(
  'absolute -left-20 lg:left-1/2 ml-auto mr-auto min-w-max -translate-x-1/2 z-999',
  {
    variants: {
      position: {
        top: 'bottom-9',
        bottom: 'top-10',
      },
      animated: {
        true: 'transform scale-0 opacity-0 pointer-events-none group-hover:scale-100 group-hover:opacity-100 group-hover:pointer-events-auto transition-all duration-200',
        false:
          'opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto group-focus-within:opacity-100 group-focus-within:pointer-events-auto transition-opacity duration-150',
      },
    },
    defaultVariants: {
      position: 'top',
      animated: false,
    },
  },
);

function Tooltip({
  title,
  position = 'top',
  animated = false,
  color,
  icon,
  parentClass,
  contentClass,
}: TooltipProps) {
  const isTop = position === 'top';

  return (
    <div
      className={twMerge(
        'group relative flex max-w-max flex-col items-center justify-center',
      )}
      data-html2canvas-ignore="true"
    >
      <button type="button" disabled className="cursor-pointer">
        {icon}
      </button>

      <div className={twMerge(tooltipContainer({ position, animated }))}>
        <div
          className={twMerge(
            'relative flex flex-col items-center',
            parentClass,
          )}
        >
          <div
            className={twMerge(
              isTop
                ? 'clip-top absolute -bottom-[7px]'
                : 'clip-bottom absolute -top-[7px]',
              'right-16 z-50 h-2 w-4 lg:right-auto',
              color,
            )}
          />
          <div
            className={twMerge(
              'text-black-600 relative w-full rounded-lg px-3 py-2 text-xs italic',
              color,
              contentClass,
            )}
          >
            {title}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tooltip;
